import colors from '../assets/theme/colors';
import SentimentVeryDissatisfiedOutlinedIcon from '@mui/icons-material/SentimentVeryDissatisfiedOutlined';
import SentimentNeutralOutlinedIcon from '@mui/icons-material/SentimentNeutralOutlined';
import SentimentSatisfiedAltOutlinedIcon from '@mui/icons-material/SentimentSatisfiedAltOutlined';
import SentimentVerySatisfiedOutlinedIcon from '@mui/icons-material/SentimentVerySatisfiedOutlined';
import MoodBadOutlinedIcon from '@mui/icons-material/MoodBadOutlined';

export const MOOD_OPTIONS = [
  {
    key: 'down',
    emoji: null,
    iconComponent: SentimentVeryDissatisfiedOutlinedIcon,
    label: 'Down',
    tint: colors.semantic.moodDown,
    color: colors.semantic.moodDown,
    aliases: ['down', 'sad', 'bad', 'upset', 'tired'],
  },
  {
    key: 'neutral',
    emoji: null,
    iconComponent: SentimentNeutralOutlinedIcon,
    label: 'Neutral',
    tint: colors.semantic.moodNeutral,
    color: colors.semantic.moodNeutral,
    aliases: ['neutral', 'okay', 'ok', 'fine', 'meh'],
  },
  {
    key: 'calm',
    emoji: null,
    iconComponent: SentimentSatisfiedAltOutlinedIcon,
    label: 'Calm',
    tint: colors.semantic.moodCalm,
    color: colors.semantic.moodCalm,
    aliases: ['calm', 'relaxed', 'peaceful', 'content'],
  },
  {
    key: 'happy',
    emoji: null,
    iconComponent: SentimentVerySatisfiedOutlinedIcon,
    label: 'Happy',
    tint: colors.semantic.moodHappy,
    color: colors.semantic.moodHappy,
    aliases: ['happy', 'good', 'great', 'joyful', 'smiling'],
  },
  {
    key: 'frustrated',
    emoji: null,
    iconComponent: MoodBadOutlinedIcon,
    label: 'Upset',
    tint: colors.semantic.moodFrustrated,
    color: colors.semantic.moodFrustrated,
    aliases: ['frustrated', 'upset', 'mad', 'angry', 'annoyed', 'stressed'],
  },
];

export const getMoodOption = (value) => {
  const normalized = String(value || '').trim().toLowerCase();
  if (!normalized) {
    return MOOD_OPTIONS[2];
  }

  return MOOD_OPTIONS.find((option) => (
    option.key === normalized
    || option.label.toLowerCase() === normalized
    || option.aliases.some((alias) => normalized.includes(alias))
  )) || MOOD_OPTIONS[2];
};

export default MOOD_OPTIONS;
